// (!) Don't forget to sync with appropriate css classes
export const MAP_PARAM_COMPLEX_EXPR = 'map-param-complex-expr'
export const MAP_PARAM_OBJECT_TAG = 'map-param-object-tag'
export const MAP_PARAM_OPERATOR = 'map-param-operator'
export const MAP_PARAM_FUNCTION = 'map-param-function'
export const MAP_PARAM_OBJECT_ID = 'map-param-obj-id'
export const MAP_PARAM_OBJECT_FIELD_NAME = 'map-param-obj-field-name' // + level of nesting from 0
